export default __webpack_public_path__ + "static/media/AstronomyEarth_00.02730063.png";